import {apolloClient} from "../../plugins/apollo-client";
import CALL_USER from '../../graphql/twilio-call/call-user.gql'
import INITIATE_CALL from '../../graphql/twilio-call/initiate-call.gql'
import INITIATE_VIDEO from '../../graphql/twilio-call/initiate-video.gql'
import COMPLETE_ROOM from '../../graphql/twilio-call/complete.gql'
import SAVE_SESSION_COORDINATES from '../../graphql/twilio-call/save-session-coordinates.gql'

const callUser = (phone) =>
  apolloClient.mutate({
    mutation: CALL_USER,
    variables: {
      phone
    }
  });

const initiateCall = (contactId, shouldRecord) =>
  apolloClient.mutate({
    mutation: INITIATE_CALL,
    variables: {
      contactId,
      shouldRecord
    }
  }).then(({data}) => data);

const initiateVideoSession = (phone) =>
  apolloClient.mutate({
    mutation: INITIATE_VIDEO,
    variables: {
      phone
    }
  }).then(({data}) => data)
    .then(({session}) => session);

const completeRoom = (roomId) =>
  apolloClient
    .mutate({
      mutation: COMPLETE_ROOM,
      variables: {roomId}
    })
    .then(({data}) => data);

const saveSessionCoordinates = (callSid, coordinates) =>
  apolloClient
    .mutate({
      mutation: SAVE_SESSION_COORDINATES,
      variables: {
        callSid, coordinates
      }
    })
    .then(({data}) => data);


export {
  callUser,
  initiateCall,
  initiateVideoSession,
  completeRoom,
  saveSessionCoordinates
}
